import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

export default function TopNavComponent() {
  const [mobileNav, setMobileNav] = useState(false);
  console.log(mobileNav);
  return (
    <>
      <div
        class={mobileNav ? "button_container active" : "button_container"}
        id="toggle"
        onClick={() => setMobileNav(!mobileNav)}
      >
        <span class="top"></span>
        <span class="middle"></span>
        <span class="bottom"></span>
      </div>
      <div class={mobileNav ? "overlay open" : "overlay"} id="overlay">
        <nav class="overlay-menu">
          <ul>
            <li>
              <a href="/" onClick={() => setMobileNav(!mobileNav)}>
                Home
              </a>
            </li>
            <li>
              <a href="/#our-value" onClick={() => setMobileNav(!mobileNav)}>
                Our Value
              </a>
            </li>
            <li>
              <a href="/#about-us" onClick={() => setMobileNav(!mobileNav)}>
                About Us
              </a>
            </li>
            <li>
              <a href="/product" onClick={() => setMobileNav(!mobileNav)}>
                Products
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}
